export enum HoverTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export interface IHover {
  hoverTheme: HoverTheme;
}
